import { CampaignsTable } from '@/components/features/campaigns'

/** Point of sale → Offers: POS-only offers (`applies_to: pos`), the ones the POS devices sync. */
const PosOffers = () => <CampaignsTable appliesTo="pos" />

export default PosOffers
